// @flow
import React, { Component } from 'react';
import { Text, Strong } from 'seek-style-guide/react';

type Props = {
  message?: SearchViewModelHeader
};

export default class FormattedMessage extends Component<Props> {
  props: Props;

  renderPart(part: SearchViewModelHeaderPart, partIndex: number) {
    const Part = part.highlighted ? Strong : 'span';
    return <Part key={partIndex}>{part.text}</Part>;
  }

  render() {
    const { message } = this.props;

    return (
      <Text small>
        {message && message.parts ? message.parts.map(this.renderPart) : null}
      </Text>
    );
  }
}
